<template>
    <div class="page singleproductPage">
        <div v-if="currentItem" class="d-flex flex-column min-h-100">
            <LocationBar/>
            <div class="descktopMediaBox">
                <div class="container">
                    <div class="backBtn" @click="$router.go(-1)">
                        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.41 11.09L2.83 6.5L7.41 1.91L6 0.5L0 6.5L6 12.5L7.41 11.09Z" fill="#653334"/>
                        </svg>
                        <span>BACK</span>
                    </div>
                    <div class="breadCr">
                        <router-link :to="{name: 'Home'}">Home</router-link>
                        <span>/</span>
                        <div>
                            <router-link :to="{name:'Menu'}">Menu</router-link>
                        </div>
                        <span>/</span>
                        <div><a @click="$router.go(-1)">{{ category_title }}</a></div>
                        <span>/</span>
                        <div v-if="currentItem">{{ currentItem.menu_title }}</div>
                    </div>
                </div>
            </div>
            <div class="singProductBox">
                <div class="frameBox">
                    <div class="imgBox" :style="{backgroundImage: 'url(\''+currentItem.photo_large+'\')'}"></div>
                    <div class="nutritionBox descktopMediaBox" v-if="cN">
                        <div class="nutEl">
                            <span class="h5">Calories</span>
                            <span>{{ cN.total_calories }}</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Carbs</span>
                            <span>{{ cN.total_carbohydrates_g }}g</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Total Fat</span>
                            <span>{{ cN.total_fat_g }}g</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Protein</span>
                            <span>{{ cN.protein_g }}g</span>
                        </div>
                        <div class="nutEl" v-if="hideNutrition">
                            <span class="h5">Fiber</span>
                            <span>{{ cN.dietary_fiber_g }}g</span>
                        </div>
                        <div class="nutEl" v-if="hideNutrition">
                            <span class="h5">Sodium</span>
                            <span>{{ cN.sodium_mg }}mg</span>
                        </div>
                        <div class="nutEl" v-if="hideNutrition">
                            <span class="h5">Sugar</span>
                            <span>{{ cN.sugars_g }}g</span>
                        </div>
                        <div class="nutEl last" v-if="hideNutrition">
                            <span class="h5">Cholesterol</span>
                            <span>{{ cN.cholesterol_mg }}mg</span>
                        </div>
                    </div>
                    <div v-if="cN" class="moreNutrition" @click="hideNutrition = !hideNutrition">
                        <span v-if="!hideNutrition">See full</span> <span v-else>Hide</span> nutritional info
                    </div>
                </div>
                <div class="rightBOx">
                    <div class="container">
                        <h2 class="colorNavy titleBox">{{currentItem.menu_title}}</h2>
                        <div class="qtText">
                            <div class="qutprice">
                                <div class="priceBox h2">
                                    ${{currentItem.totalPrice()}} <span v-if="cN">/ {{currentItem.totalCall()}} cal</span>
                                </div>
                                <div class="quantityBox" v-if="category_title.toLowerCase()!='bagel' && category_title.toLowerCase()!='bagels'">
                                    <div @click="currentItem.changeQuantity(-1)">
                                        <svg width="24" height="4" viewBox="0 0 24 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.333374 2H23.6667" stroke="#B72D24" stroke-width="4"/>
                                        </svg>
                                    </div>
                                    <div class="qty button">
                                        {{currentItem.quantity}}
                                    </div>
                                    <div @click="currentItem.changeQuantity(1)">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M23.6666 13.6667H13.6666V23.6667H10.3333V13.6667H0.333252V10.3333H10.3333V0.333328H13.6666V10.3333H23.6666V13.6667Z"
                                                  fill="#B72D24"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="regText" v-if="currentItem.menu_description" v-html="currentItem.menu_description.replace(/(<([^>]+)>)/ig,'')"></div>
                        </div>
                    </div>
                    <Addons/>
                </div>
                <div class="nutritionBox mediaHideOnDesctop" v-if="cN">
                    <div class="container">
                        <h5>NUTRITION:</h5>
                        <div class="nutEl">
                            <span class="h5">Calories</span>
                            <span>{{ cN.total_calories }}</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Protein</span>
                            <span>{{ cN.protein_g }}g</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Fiber</span>
                            <span>{{ cN.dietary_fiber_g }}g</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Carbs</span>
                            <span>{{ cN.total_carbohydrates_g }}g</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Total Fat</span>
                            <span>{{ cN.total_fat_g }}g</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Sodium</span>
                            <span>{{ cN.sodium_mg }}mg</span>
                        </div>
                        <div class="nutEl">
                            <span class="h5">Sugar</span>
                            <span>{{ cN.sugars_g }}g</span>
                        </div>
                        <div class="nutEl last">
                            <span class="h5">Cholesterol</span>
                            <span>{{ cN.cholesterol_mg }}mg</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="botBtn mt-auto" v-if="parseInt(cart.business.order_ability) === 1 && parseInt(cart.business.takeout) === 1">
                <div class="container">
                    <button class="zbg" @click="addToCart()">
                        <span>Add to order</span> <i>-</i> <span>${{currentItem.totalPrice()}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LocationBar from "../../components/menu/LocationBar";
    import Addons from "../../components/menu/Addons";

    export default {
        name: "SingleItem",
        data() {
            return {
                hideNutrition: false
            }
        },
        components: {Addons, LocationBar},
        created() {
            // Edit cart product
            if (typeof this.$route.query.cartItem !== "undefined") {
                if (this.cart.products[this.$route.query.cartItem]) {
                    this.$store.commit("menu/setCurrentItem", {asItIs: true, item: JSON.parse(JSON.stringify(this.cart.products[this.$route.query.cartItem]))});

                } else {
                    this.$router.push({name: "MenuList"});
                }
            } else {
                /*get new product*/
                this.$store.dispatch("menu/getMenuItem", {
                    itemId: this.$route.params.id,
                    callback: () => {
                        //Setting up defaults
                        let element = {};
                        this.currentItem.modifiers.map(m => {
                            if (m.quantity_ability !== "1") {
                                m.options.map(opt => {
                                    if (opt.default_value === "1") {
                                        this.currentItem.toggleOption(opt)
                                    }
                                })
                            }
                        })
                    }
                });
            }
        },
        computed: {
            currentItem() {
                if (this.$store.state.menu.currentItem) {
                    this.$store.commit("shared/setTopBar", {title: this.$store.state.menu.currentItem.menu_title, showBackButton: true, showBag: true});
                }
                return this.$store.state.menu.currentItem
            },
            cN() {
                return this.$store.state.menu.currentItem.nutritional_facts
            },
            cart() {
                return this.$store.state.cart.cart
            },
            category_title(){
                return this.$store.state.menu.menu?.findCategoryById(this.currentItem.category_id)?.name || ""
            }
        },
        methods: {
            addToCart() {
                //check for requards
                const required = this.currentItem.modifiers.filter(el => el.required == 1);
                let error = "";

                required.map(el => {
                    let totalSelected = 0;
                    Object.keys(this.currentItem.activeModifiers).map(key => {
                        if (el.id == this.currentItem.activeModifiers[key].addon_id) {
                            totalSelected++
                        }
                    });
                    if (!totalSelected) {
                        error = `<h4><span>Please, select all required options</span></h4>`;
                    }
                });

                if (error) {
                    this.$store.commit("shared/setAlert", error);
                    return false;
                }

                let cartIndex = false;
                if (typeof this.$route.query.cartItem !== "undefined") {
                    this.$store.commit("cart/updateCart", {index: this.$route.query.cartItem, item: this.currentItem});
                    this.$store.commit("shared/setAlert", `your Bag has been updated`);
                    this.$router.push({name: "Cart"});
                } else {
                    this.$store.commit("cart/addToCart", this.currentItem);
                    this.$store.commit("shared/setAlert", `<span>+${this.currentItem.quantity}</span> Item added to Bag`);
                    this.$router.push({name: "Menu"});
                }
            }
        },
        destroyed() {
            this.$store.commit("menu/setCurrentItem", null);
        }
    }
</script>
